import { Navigation } from "lucide-react";
import { directionsUrl } from "../lib/directions";

/* Small "Directions" deep-link button — opens Google Maps navigation to the place.
   Pass lat/lon when known (exact), otherwise name/address (search-based). */
export const DirectionsButton = ({ lat, lon, name, address, label = "Directions", size = "sm", className = "", testid = "directions-btn" }) => {
  const url = directionsUrl({ lat, lon, name, address });
  if (size === "icon") {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" title={`Directions to ${name || address || "this place"}`}
        data-testid={testid} className={`p-1 text-zinc-400 hover:text-emerald-600 ${className}`}>
        <Navigation className="w-4 h-4" />
      </a>
    );
  }
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" data-testid={testid}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 border border-emerald-600 text-emerald-700 text-xs font-700 hover:bg-emerald-50 transition-colors ${className}`}>
      <Navigation className="w-3.5 h-3.5" /> {label}
    </a>
  );
};
